import axios from "axios";

const API_BASE_URL = "https://backend.ingazcon.mtjrsahl-ksa.com/api";
const Language = localStorage.getItem("language")
const LanguagenextLng = localStorage.getItem("i18nextLng")

const axiosInstance = axios.create({
    baseURL: API_BASE_URL,
    headers: {
        "Content-Type": "application/json",
        "Accept-Language": Language || LanguagenextLng || 'ar'
    },
});

axiosInstance.interceptors.request.use((config) => {
    const token = localStorage.getItem("token");
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

axiosInstance.interceptors.response.use(
    (response) => response,
    (error) => {
        console.error("API Error:", error.response || error.message);
        return Promise.reject(error);
    }
);

export default axiosInstance;